import React, { useState, useEffect } from "react";
import { FleetDataContext } from "./context";

import { getFleetData } from "../services/services";

const FleetProvider = ({ children }) => {
  const [fleetData, setFleetData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFleet = async () => {
      const fleet = await getFleetData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      setFleetData(fleet);
    };

    fetchFleet();
  }, []);

  return (
    <FleetDataContext.Provider
      value={{ fleetData, setFleetData, loading, error }}
    >
      {children}
    </FleetDataContext.Provider>
  );
};

export default FleetProvider;
